import { FC } from "react";
import { useTranslation } from "react-i18next";
import SaleTabPane, { TabProps } from "@/components/TabPane";
import PackingList from "./components/PackList";
import { PackOrder } from "@/types/packing";

type CustomerTabType = 'doc'

const PurchaseOrderHome: FC = () => {
  const { t } = useTranslation();
  const TAB_LIST_KEY = "list"
  const TAB_KEY = "doc"

  const keyObj: (info: PackOrder) => { [key in CustomerTabType]: TabProps } = (info) => ({
    doc: {
      key: TAB_KEY,
      label: (info.number),
      children: <></>
    },
  })


  return <SaleTabPane<PackOrder> defaultKey={TAB_LIST_KEY} defaultTabs={[
    {
      key: TAB_LIST_KEY,
      label: t("warehouse.packing"),
      children: <PackingList />,
      closable: false,
    },
  ]} onOpens={(info) => keyObj(info)} />
}

export default PurchaseOrderHome;